import { resolveTicketAmount } from "./expenseUserAmount";

/**
 * Claves i18n compartidas (ExpenseUser.*) para estados y etiquetas de chips.
 * @param {import("i18next").TFunction} t
 * @param {string} s
 */
export function expenseUserStatusLabel(t, s) {
  const k = `ExpenseUser.status.${s}`;
  return t(k, { defaultValue: String(s || "") });
}

/**
 * "Importe: X" o guión si no hay importe.
 * @param {import("i18next").TFunction} t
 * @param {object} row
 */
export function ticketAmountLine(t, row) {
  const { total, currency } = resolveTicketAmount(row);
  if (!Number.isFinite(total) || total <= 0) {
    return t("ExpenseUser.amountEmpty");
  }
  try {
    const formatted = new Intl.NumberFormat(undefined, {
      style: "currency",
      currency: currency || "EUR",
    }).format(total);
    return t("ExpenseUser.amountFormatted", { amount: formatted });
  } catch {
    return t("ExpenseUser.amountRaw", {
      value: total.toFixed(2),
      currency: currency || "EUR",
    });
  }
}
